"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setQueryString = exports.parse = void 0;
const url = require("url");
function parse(inputUrl) {
    return url.parse(inputUrl, true);
}
exports.parse = parse;
function setQueryString(paramObj, replaceState = false, clearExisting = false) {
    const { query } = url.parse(window.location.href, true);
    let newParams = Object.assign(Object.assign({}, query), paramObj);
    if (clearExisting) {
        newParams = Object.assign({}, paramObj);
    }
    let queryString = Object.keys(newParams)
        .map((key) => {
        return (newParams[key]) ? `${key}=${newParams[key]}` : null;
    })
        .filter(item => !!item)
        .join('&');
    if (queryString)
        queryString = '?' + queryString;
    const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}${queryString}`;
    if (replaceState && window.history.replaceState) {
        window.history.replaceState({ path: newUrl }, '', newUrl);
    }
    else if (window.history.pushState) {
        window.history.pushState({ path: newUrl }, '', newUrl);
    }
    return newUrl;
}
exports.setQueryString = setQueryString;
//# sourceMappingURL=UrlUtil.js.map